<form class="visualization" [formGroup]="form">
  <div class="axleRangeWrapper">
    <div class="frontLoad" [class.setFrontLoad]="isSwitchSet">
      <div class="label" #labelElement>
        @for (axle of axles; track axle; let axleIndex = $index) {
          <div
            [class.activeAxle]="selectedAxle - 1 === axleIndex">
            <div class="value" [style.left.px]="getAxleValue(axleIndex)">
              @if (checkAxleValue(axleIndex)) {
                {{ getRealAxleValue(axleIndex) }}
              }
            </div>
            <div class="drop" [style.left.px]="getAxleValue(axleIndex)"></div>
          </div>
        }
      </div>
      @for (axle of numberOfAxles; track axle) {
        <input
          [class.activeInput]="selectedAxle - 1 === axle"
          class="inputRange"
          [ngClass]="{ 'print': isPrint }"
          [max]="inputRange"
          type="range"
          [formControlName]="axle"
          [attr.disabled]="selectedAxle - 1 !== axle ? 'disabled' : null"
          />
      }
    </div>
  </div>
</form>
